import { connect } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import type { ProductImagesCarouselProps } from 'src/components/organisms/ProductImagesCarousel/components/ProductImagesCarousel';
import { ProductImagesCarousel } from 'src/components/organisms/ProductImagesCarousel/components/ProductImagesCarousel';
import type {
  NextOrPreviousPayload,
  OpenModalPayload,
  SetCurrentImagePayload,
} from 'src/components/organisms/ProductImagesCarousel/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectFavouriteProduct } from 'src/redux/favourites/selectors';
import { selectProduct } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productImagesCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState) => {
  return {
    product: selectProduct(state),
    currentImage: state.productImagesCarousel.currentImage,
    navigatedBy: state.productImagesCarousel.navigatedBy,
    isModalOpen: state.productImagesCarousel.isModalOpen,
    favouriteProduct: selectFavouriteProduct(state),
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch) => {
  return {
    closeModal: () => dispatch(actions.closeModal()),
    dispatchOnUpdateFavourite: (productCode: number) =>
      dispatch(updateFavourite({ productCode, nextConfig })),
    onNextImage: (payload: NextOrPreviousPayload) => dispatch(actions.nextImage(payload)),
    onOpenModal: (payload: OpenModalPayload) => dispatch(actions.openModal(payload)),
    onPrevImage: (payload: NextOrPreviousPayload) => dispatch(actions.prevImage(payload)),
    setCurrentImage: (payload: SetCurrentImagePayload) =>
      dispatch(actions.setCurrentImage(payload)),
  };
};

const mergeProps = (
  propsFromState: ReturnType<typeof mapStateToProps>,
  propsFromDispatch: ReturnType<typeof mapDispatchToProps>,
): ProductImagesCarouselProps => {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    productIsFavourited: propsFromState.favouriteProduct.isFavourited,
    onUpdateFavourite: () =>
      propsFromDispatch.dispatchOnUpdateFavourite(propsFromState.favouriteProduct.code),
  };
};

export const ProductImagesCarouselContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ProductImagesCarousel);
